import { Digits } from '@core/enums/digits.enum';
import { ISettingModel } from '@models/settings/settings.model';

export class DataHelper {
  static IsJsonString(str: string) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }

  static convertToNumber = (number: string): number => {
    return Number(number);
  };

  static IsNumber(value: any) {
    return !isNaN(parseInt(value));
  }
  static IsNumberStrict(value: any) {
    return !isNaN(Number(value));
  }

  static isEmpty(value: any) {
    if (value === null || value === undefined || value === '') {
      return true;
    }
    return false;
  }

  static isNotEmptyArray(value: any) {
    return Array.isArray(value) && Array.from(value).length > 0;
  }

  // Turn enum into array
  static enumToArray = (enumeration) => {
    return Object.keys(enumeration)
      .filter(DataHelper.IsNumber)
      .map((key) => enumeration[key]);
  };

  static enumToArrayStrict = (enumeration) => {
    return Object.keys(enumeration)
      .filter(DataHelper.IsNumberStrict)
      .map((key) => enumeration[key]);
  };

  static enumToArrayInDeclarationOrder = (enumeration: any): string[] => {
    return Object.keys(enumeration)
      .filter(key => isNaN(Number(key)));
  };

  static enumValuesToArray = (enumeration) => {
    return Object.values(enumeration)
      .filter(DataHelper.IsNumber)
      .map((value) => value);
  };

  static replaceAll = (str, oldChar, newChar) => {
    const regex = new RegExp(`${oldChar}`, 'g');
    return str?.replace(regex, newChar);
  };

  static formatStatusName = (name: string): string => {
    return name ? name.replace(/_/g, ' ') : '';
  };

  static getQuotedMobile = (mobile: string, isdCode: string = '') => {
    return `${
      isdCode +
      'X'.repeat(mobile?.length - 4) +
      mobile?.slice(mobile?.length - 4, mobile?.length)
    }`;
  };
}

export const stringAvatar = (name) => {
  const shortName =
    name.split(' ').length == 1
      ? `${name.split(' ')[0][0]}${name.split(' ')[0][1]}`
      : name.split(' ').length == 3
      ? `${name.split(' ')[1][0]}${name.split(' ')[2][0]}`
      : `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`;
  return shortName;
};

export const getSettingsByName = (
  settings: Array<ISettingModel>,
  settingName: string
): ISettingModel => {
  return settings?.find((s) => s.settingName === settingName);
};

export const convertKeysToLowerCase = (objectArray) => {
  return objectArray.map((object) => {
    const newObject = {};
    for (const key in object) {
      if (Object.prototype.hasOwnProperty.call(object, key)) {
        const newKey = key.charAt(0).toLowerCase() + key.slice(1);
        newObject[newKey] = object[key];
      }
    }
    return newObject;
  });
};

export const toFixed = (value: number, decimals = 2) => {
  value = Number(Math.round(Number(value + 'e' + decimals)) + 'e-' + decimals);
  return !isNaN(value)
    ? value?.toFixed(decimals)
    : Digits.Zero.toFixed(decimals);
};
